import { IIncomeType, ISaveIncomeType, supportApi } from '../../shared';
import { NewBaseClient } from '../../shared/clients/new-base.client';

class IncomeTypeClient extends NewBaseClient<ISaveIncomeType, IIncomeType> {
    constructor() {
        super(supportApi, '/income-types');
    }
}

export const incomeTypeClient = new IncomeTypeClient();
